module.exports = __webpack_public_path__ + "static/media/rugby-icon.7ca168eb.webp";